import { ActionPointType } from "./_enum/action-point.enum";

export class ActionPointCampaignConfiguration {
    private copyConfiguration? : CopyActionPointConfiguration
    private campaignSequenceDestination : number 

    constructor(campaignSequenceDestination : number){
        this.campaignSequenceDestination = campaignSequenceDestination
    }
    public addCopyConfiguration(campaign : number, actions : ActionPointType[], catalog : boolean){
        this.copyConfiguration = new CopyActionPointConfiguration(campaign, actions, catalog)
    }

    public getDestination() : number {
        return this.campaignSequenceDestination;
    }
}

class CopyActionPointConfiguration {
    private campaignSequence : number
    private actions : ActionPointType[]
    private catalog : boolean

    constructor(campaign : number, actions : ActionPointType[], catalog : boolean) {
        this.campaignSequence = campaign
        this.actions = actions
        this.catalog = catalog
    }
}